import type { FC } from 'react';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { spAppMainPages } from '@pflegenavi/frontend/routing';
import { useGetServiceProviderPhoenix } from '@pflegenavi/service-provider-frontend/api';
import { useKycIdvDialogState } from '@pflegenavi/web-components';
import {
  SERVICE_PROVIDER_KYC_SUBJECT as SUBJECT,
  ServiceProviderKycIdvDialog,
} from '../kyc/ServiceProviderKycIdvDialog';
import {
  getServiceProviderKycWarning,
  isHostedIdvEnabled,
} from './serviceProviderKycWarning';
import { KycVerificationBannerView } from './KycVerificationBannerView';

/** Dashboard banner prompting service providers to complete or renew MangoPay KYC. */
export const KycVerificationBanner: FC = () => {
  const navigate = useNavigate();
  const { openFor, openDialog, closeDialog, returnUrlFor } =
    useKycIdvDialogState<typeof SUBJECT>();

  const { data: serviceProvider } = useGetServiceProviderPhoenix();
  const hostedIdv = isHostedIdvEnabled(serviceProvider?.data);
  const warning = getServiceProviderKycWarning(
    serviceProvider?.data,
    new Date()
  );

  const handleAction = useCallback(() => {
    if (hostedIdv) {
      openDialog(SUBJECT);
    } else {
      navigate(spAppMainPages.PROFILE);
    }
  }, [hostedIdv, navigate, openDialog]);

  return (
    <>
      {warning && (
        <KycVerificationBannerView
          warning={warning}
          hostedIdv={hostedIdv}
          renewalDeadline={serviceProvider?.data.kyc_renewal_deadline ?? null}
          onAction={handleAction}
        />
      )}
      {hostedIdv && (
        <ServiceProviderKycIdvDialog
          open={openFor === SUBJECT}
          onClose={closeDialog}
          returnUrl={returnUrlFor(SUBJECT)}
        />
      )}
    </>
  );
};
